import { PaywallAuthErrorCodes, SiteLinks, PaywallPlans, PremiumPaywallSignModes } from "../../../../../global/paywall/paywallInterfaces";
import { PremiumPaywallState } from "../premiumPaywallDesktop";
interface PremiumPaywallDesktopSigninEmailProps {
  email: string
  setEmail: (email: string) => void
  setMode: (state: PremiumPaywallState) => void
  loginWithGoogle: () => void
  loginWithApple: () => void
  sendMail: () => void
  authError: string
  isNewspaper?: boolean;
  setAuthError?: (error: PaywallAuthErrorCodes) => void;
}


interface PremiumPaywallSigninEmailNewspaperProps extends PremiumPaywallDesktopSigninEmailProps {

  handleMailChange: (e: any) => void;
  handleSendMail: () => void;
  isMobile?: boolean;
  contactUrl: string;
  handleEmailReset: () => void;
}

const errorMessagesFront: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.INVALID_EMAIL]: 'כתובת דוא"ל אינה תקינה',
};

const errorMessagesServer: Partial<Record<PaywallAuthErrorCodes, string>> = {
  [PaywallAuthErrorCodes.FAILED_TO_SEND_OTP]: "אירעה שגיאה במערכת, אנא נסו שוב מאוחר יותר",
  [PaywallAuthErrorCodes.NOT_REGISTERED]: 'כתובת דוא"ל לא קיימת במערכת',
  [PaywallAuthErrorCodes.OTP_MAX_ATTEMPTS]: "חרגת ממספר בקשות אימות. יש לפנות לשירות לקוחות",
}

declare const window: Window & {
  PAYWALL_SITE_LINKS: SiteLinks;
}
export const PremiumPaywallDesktopSigninEmail = (props: PremiumPaywallDesktopSigninEmailProps) => {

  const { email, setEmail, loginWithApple, loginWithGoogle, setMode, sendMail, authError, isNewspaper, setAuthError } = props
  const handleMailChange = (e) => {
    setEmail(e.target.value)
    if (e.target.value.length === 0 && authError) {
      setAuthError(null);
    }
  }

  const handleSendMail = () => {
    sendMail();
     const accountSendMailAnalytics = new CustomEvent("accountSendMailAnalytics",  { detail: { label: "signin" } })
      document.dispatchEvent(accountSendMailAnalytics);
  }
const loginEvent =(mode)=>{
    setMode({ mode: mode })    
    const loginButtonEvent = new CustomEvent("loginButtonEvent",   { detail: {  mode: mode } })
    document.dispatchEvent(loginButtonEvent);
}
const handleNewspaperRegister = (mode:PremiumPaywallSignModes) => {
    setMode({ mode: mode, isNewspaper: true })
    const newspaperRegisterEvent = new CustomEvent("handleNewspaperRegister")
    document.dispatchEvent(newspaperRegisterEvent);
}
const loginWithThirdPartyEvent=(type:string)=>{
  type==="google" ? loginWithGoogle() : loginWithApple();
   const handleThirdPartyLogin = new CustomEvent("handleThirdPartyLogin", { detail: { loginMethod: type,  type: "signin" } })
    document.dispatchEvent(handleThirdPartyLogin);
}
  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }

  const handleEmailReset = () => {
    setEmail('');
    setAuthError(null);
  }

  const contactUrl = typeof window !== "undefined" && window.PAYWALL_SITE_LINKS ? window.PAYWALL_SITE_LINKS.contact : '';

  if (isNewspaper) {
    return <PremiumPaywallSigninEmailNewspaper {...props} handleEmailReset={handleEmailReset} contactUrl={contactUrl} handleSendMail={handleSendMail} handleMailChange={handleMailChange} />
  } else {
    return (
      <div className="premium-paywall-desktop-signin-email">
        <h1 className="title">כניסה</h1>
        <div className={`email-signin ${authError ? 'error' : ''}`}>
          <input onKeyDown={handlePressKey} value={email} onChange={handleMailChange} type="email" placeholder='הקלידו כתובת דוא"ל' />
          {email && <div className="reset-icon" onClick={handleEmailReset}></div>}
          {
            authError === PaywallAuthErrorCodes.INVALID_EMAIL ? (
              <p className="error-text">{errorMessagesFront[authError]}</p>
            ) : (
              <p
                className="error-text"
                dangerouslySetInnerHTML={{ __html: errorMessagesServer[authError] }}
              />
            )
          }
        </div>
        <div className="buttons-container">
          <button disabled={!email.length} className="button-base continue" onClick={handleSendMail}>המשך</button>
        </div>
        <div className="separator">
          <div className="line" />
          <span className="text">או באמצעות</span>
          <div className="line" />
        </div>
        <div className="social-signin">
          <button className="social-button google-btn" onClick={() => loginWithThirdPartyEvent('google')}><span>גוגל</span></button>
          <button className="social-button apple-btn" onClick={() => loginWithThirdPartyEvent('apple')}><span>אפל</span></button>
        </div>
        <div className="login">
          <div>לא מנויים? <button type="button" onClick={() => loginEvent('signUp')}>לרכישת מינוי</button></div>
        </div>
        <div className="newspaper-users" >
          <div><span>מנויים לעיתון</span> <span className="yedioth-label"></span></div>
          <div onClick={() => handleNewspaperRegister('signIn')} className="newspaper-register-text">צרו חשבון ל-<div className="yedioth-plus-label"></div>ללא עלות</div>
        </div>
      </div>
    )
  }
}


export const PremiumPaywallSigninEmailNewspaper = (props: PremiumPaywallSigninEmailNewspaperProps) => {
  const { email, setEmail, authError, handleMailChange, handleSendMail, isMobile, contactUrl, handleEmailReset } = props;

  const handlePressKey = (e) => {
    if (e.key === 'Enter') {
      handleSendMail();
    }
  }
  return (
    <div className={`premium-paywall-${isMobile ? 'mobile' : 'desktop'}-signin-email newspaper`}>
      <div className="title-container"><span> כניסה למנויי </span><span className="yedioth-label-newspaper-mode"></span></div>
      <div className={`email-signin ${authError && authError.includes('EMAIL') ? 'error' : ''}`}>
        <input onKeyPress={handlePressKey} value={email} onChange={handleMailChange} type="email" placeholder='הקלידו כתובת דוא"ל' />
        {email && <div className="reset-icon" onClick={handleEmailReset}></div>}
                {
            authError === PaywallAuthErrorCodes.INVALID_EMAIL ? (
              <p className="error-text">{errorMessagesFront[authError]}</p>
            ) : (
              <p
                className="error-text"
                dangerouslySetInnerHTML={{ __html: errorMessagesServer[authError] }}
              />
            )
          }
      </div>
      <div className="buttons-container">
        <button disabled={!email.length} className="button-base continue" onClick={handleSendMail}>המשך</button>
      </div>
      {authError && <p className="error-text" dangerouslySetInnerHTML={{ __html: errorMessagesServer[authError] }}></p>}

      <div className="login">
        <div>לא זוכרים עם איזו כתובת דוא"ל נרשמתם? <a target="_blank" href={contactUrl}>צרו איתנו קשר</a></div>
      </div>
    </div>
  )

}